import {
  GET_DOMAINS,
  GET_ROOMS,
  GET_ADVICES,
  SET_DOMAINS,
  SET_ROOMS,
  SET_ADVICES,
  GET_DOMAINS_ERROR,
  GET_ROOMS_ERROR,
  GET_ADVICES_ERROR,
  RESET_DOMAINS,
  RESET_ROOMS,
  RESET_ADVICES,
  SET_ADVICE_ID,
  SET_ADVICE_FILTERS,
  RESET_ADVICE_FILTERS,
  SET_DOMAIN_ROOMS_SELECTION
} from './types'
import { RESET_TOKEN, SET_ACTIVE_WORKSPACE } from 'utils/auth/types'

const initialAdviceFilters = {
  countries: [],
  group: null,
  status: null,
  assignee: null,
  dateRange: null
}

const initialState = {
  domains: [],
  rooms: [],
  advices: [],
  advicesNext: null,
  isLoadingDomains: false,
  isLoadingRooms: false,
  isLoadingAdvices: false,
  adviceId: null,
  adviceFilters: initialAdviceFilters,
  // The domain/rooms picked in each page's DomainsRoomsFilter, keyed by page
  // ({ advices: { domain, rooms }, laws: ... }), kept while the user navigates
  // elsewhere. Domains, rooms and groups belong to a workspace, so they are
  // dropped when the workspace changes.
  domainRoomsSelections: {},
  filtersWorkspaceId: null
}

const clearedSelection = {
  adviceFilters: initialAdviceFilters,
  domainRoomsSelections: {}
}

const advicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOMAINS:
      return {
        ...state,
        isLoadingDomains: true
      }
    case GET_ROOMS:
      return {
        ...state,
        isLoadingRooms: true
      }
    case GET_ADVICES:
      return {
        ...state,
        isLoadingAdvices: true
      }
    case SET_DOMAINS:
      return {
        ...state,
        domains: action.payload.domains,
        isLoadingDomains: false
      }
    case SET_ROOMS:
      return {
        ...state,
        rooms: action.payload.rooms,
        isLoadingRooms: false
      }
    case SET_ADVICES:
      return {
        ...state,
        advices: action.payload.advices,
        advicesNext: action.payload.advicesNext,
        isLoadingAdvices: false
      }
    case GET_DOMAINS_ERROR:
      return {
        ...state,
        isLoadingDomains: false
      }
    case GET_ROOMS_ERROR:
      return {
        ...state,
        isLoadingRooms: false
      }
    case GET_ADVICES_ERROR:
      return {
        ...state,
        isLoadingAdvices: false
      }
    case RESET_DOMAINS:
      return {
        ...state,
        domains: [],
        isLoadingDomains: false
      }
    case RESET_ROOMS:
      return {
        ...state,
        rooms: [],
        isLoadingRooms: false
      }
    case RESET_ADVICES:
      return {
        ...state,
        advices: [],
        isLoadingAdvices: false
      }
    case SET_ADVICE_ID:
      return {
        ...state,
        adviceId: action.payload.adviceId
      }
    case SET_ADVICE_FILTERS:
      return {
        ...state,
        adviceFilters: {
          ...state.adviceFilters,
          ...action.payload.filters
        }
      }
    case RESET_ADVICE_FILTERS:
      // The date range has its own button and clear badge, so clearing the
      // filter menu leaves it in place
      return {
        ...state,
        adviceFilters: {
          ...initialAdviceFilters,
          dateRange: state.adviceFilters.dateRange
        }
      }
    case SET_DOMAIN_ROOMS_SELECTION:
      return {
        ...state,
        domainRoomsSelections: {
          ...state.domainRoomsSelections,
          [action.payload.page]: {
            domain: action.payload.domain,
            rooms: action.payload.rooms
          }
        }
      }
    case SET_ACTIVE_WORKSPACE: {
      const workspaceId = action.payload.activeWorkspace.id
      if (workspaceId === state.filtersWorkspaceId) {
        return state
      }
      return {
        ...state,
        ...clearedSelection,
        filtersWorkspaceId: workspaceId
      }
    }
    case RESET_TOKEN:
      return {
        ...state,
        ...clearedSelection,
        filtersWorkspaceId: null
      }
    default:
      return state
  }
}

export default advicesReducer
